export default {"src":"/_next/static/media/surgeon_64.ceaedc0b.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};